import * as types from "./constant"

export const InitialPaymentStart = payload => ({
  type: types.initial_Payament_start,
  payload,
})
export const InitialPaymentSuccess = payload => ({
  type: types.initial_Payament_success,
  payload,
})
export const InitialPaymentFailure = error => ({
  type: types.initial_Payament_failed,
  payload: error,
})
export const InitialPaymentReset = () => ({})

// get coupon id

export const getCouponStart = payload => ({
  type: types.get_coupon_start,
  payload,
})
export const getCouponSuccess = payload => ({
  type: types.get_coupon_success,
  payload,
})
export const getCouponFailure = error => ({
  type: types.get_coupon_fail,
  payload: error,
})
export const getCouponReset = () => ({
  type: types.get_coupon_reset
})
